/**
 * Takes down the boot splash that index.html paints before React exists.
 *
 * The markup and styles live in index.html on purpose — they have to be on
 * screen before any bundle has parsed. This is only the dismissal.
 */

/**
 * Length of the slash animation the app plays, in ms. Must match the clip
 * produced by scripts/build-splash-animation.mjs.
 */
const SPLASH_MS = 1760

export function dismissBootSplash() {
    const splash = document.getElementById('boot-splash')
    if (!splash) return

    // The app plays an animation and should not be cut off mid-swing; the
    // browser shows a still mark and must never be made to wait. index.html
    // sets is-native, so this needs no Capacitor import.
    const animated = document.documentElement.classList.contains('is-native')

    // ponytail: measured from navigation start, not from the frame the clip
    // first painted. The clip ships inside the app, so those are a few dozen ms
    // apart there. Stamp the img's load event if that ever stops being true.
    const remaining = animated ? Math.max(0, SPLASH_MS - performance.now()) : 0
    setTimeout(() => splash.classList.add('is-done'), remaining)
}
